import {
  autoClosedColorResolver,
  closedColorResolver,
  defaultColorResolver,
  newColorResolver,
  overdueMitigationColorResolver,
  pendingMitigationColorResolver,
  type ColorResolver,
  underReviewColorResolver,
} from './sharedStatusColorResolvers';

const STATUS_COLOR_RESOLVERS: Record<string, ColorResolver> = {
  new: newColorResolver,
  'under review': underReviewColorResolver,
  'pending mitigation': pendingMitigationColorResolver,
  'overdue mitigation': overdueMitigationColorResolver,
  closed: closedColorResolver,
  'auto closed': autoClosedColorResolver,
};

export const CoiStatusColorMap = (status?: string): ColorResolver =>
  STATUS_COLOR_RESOLVERS[status?.toLowerCase() ?? ''] ?? defaultColorResolver;
